module.exports = __webpack_public_path__ + "static/media/recentWhite.0134505d.svg";